import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';

const StrapiHeader = (props) => {
    const authData = Array.isArray(props.data) && props.data.filter((item) => item.authorised_user === true);

    const [sectionName, setSectionName] = useState();

    useEffect(() => {
        switch (props.menuSection) {
            case 'personal':
            case undefined:
                setSectionName('personal');
                break;
            default:
                setSectionName(props.menuSection);
        }
    }, [props.menuSection]);

    const newMenuSortedData = props.data ? props.data.sort((a, b) => a.position - b.position) : [];

    return (
        <>
            {props.isShowNavModal && props.data && (
                <HeaderMobile
                    data={newMenuSortedData}
                    sectionName={sectionName}
                    isLanding={props.isLanding}
                    authData={authData}
                    pageName={props.pageName}
                    libre={props.libre}
                />
            )}
            {!props.loading && props.data && (
                <HeaderDesktop
                    data={newMenuSortedData}
                    sectionName={sectionName}
                    isLanding={props.isLanding}
                    authData={authData}
                    pageName={props.pageName}
                    libre={props.libre}
                />
            )}
        </>
    );
};

StrapiHeader.propTypes = {
    isShowNavModal: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([undefined])]),
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([undefined])]),
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.oneOf([null])]),
    isLanding: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([undefined])]),
    menuSection: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([undefined, null])]),
};

export default StrapiHeader;
